export function formatCountryDisplayName(name: string): string {
	const trimmed = name.trim();
	if (!trimmed) {
		return name;
	}

	const titleCaseSegment = (segment: string) => {
		if (!segment) {
			return segment;
		}
		return segment[0].toUpperCase() + segment.slice(1).toLowerCase();
	};

	return trimmed
		.split(/\s+/)
		.map((word) => word.split("-").map(titleCaseSegment).join("-"))
		.join(" ");
}
